import { useContext } from 'react';
import { Context } from './context';
export function useAuth() {
    const context = useContext(Context);
    if (!context)
        throw new Error('useAuth() requires an <AuthProvider />');
    return context;
}
export function useAuthenticated() {
    const context = useAuth();
    if (!context.authenticated)
        throw new Error('Unauthenticated!');
    return context;
}
export function useAccessToken() {
    const context = useContext(Context);
    return context && 'getAccessToken' in context
        ? context.getAccessToken
        : () => Promise.resolve(undefined);
}
